/**
 * Display name for the product host the user is currently on.
 * Matches the title logic in src/app.vue.
 */
export function productBrandName(origin = window.location.origin, opts = {}) {
  const { isRepuAgency = false, isZenSocial = false, config = null } = opts

  if (config && config.custom_domain) {
    return String(config.custom_domain)
  }
  if (origin === 'https://app.showmyrep.io') return 'ShowMyRep'
  if (origin.includes('tapengine.io')) return 'TapEngine'
  if (origin.includes('getsocialreviews.com')) return 'Social Reviews'
  if (origin.includes('reviewsurge.co')) return 'ReviewSurge'
  if (origin.includes('rvrply.com')) return 'RVRPLY'
  if (origin.includes('leadmachine.io')) return 'Lead Machine'
  if (origin.includes('socialfusionai.com')) return 'Social Fusion'
  if (origin.includes('instastream.co')) return 'InstaStream'
  if (origin.includes('zensocial.io') || isZenSocial) return 'ZenSocial'
  if (origin.includes('reputationhub.io')) return 'ReputationHub'
  if (origin.includes('replyengine.io')) return 'ReplyEngine'
  if (origin.includes('repuagency.com') || isRepuAgency) return 'RepuAgency'
  return 'ReplyEngine'
}
